/* Coque-sublimation.fr – pré-commande : choix d'envoi dans le panier + dates dans la langue de la page
   Par défaut (panier mixte stock + pré-commande) : 2 envois, frais du 2e colis ajoutés automatiquement.
   Le client peut repasser en « un seul colis » (frais retirés) : une ligne à 0 €
   « Expédition dès que la pré-commande sera disponible » est alors ajoutée (trace pour le préparateur). */
(function () {
  if (window.csPreorderInit) return;
  window.csPreorderInit = true;
  var ATTR = 'Expédition pré-commande';
  var SPLIT = 'Deux envois (stock maintenant, pré-commande à réception)';
  var SINGLE = 'Un seul colis (à réception de la pré-commande)';
  var busy = false;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }
  function setAttr(v) { var a = {}; a[ATTR] = v; return post('/cart/update.js', { attributes: a }); }
  function setQty(variant, qty) { return post('/cart/change.js', { id: String(variant), quantity: qty }); }
  function addWait(s) { return s.waitVariant ? post('/cart/add.js', { items: [{ id: Number(s.waitVariant), quantity: 1 }] }) : Promise.resolve(); }
  function state() {
    var els = document.querySelectorAll('.cs-po-state');
    return els.length ? els[els.length - 1].dataset : null;
  }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  /* Rafraîchit le panier latéral sans recharger la page (il reste ouvert) */
  function refresh() {
    if (onCartPage() || !document.getElementById('CartDrawer')) { window.location.reload(); return Promise.resolve(); }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
        var drawer = document.getElementById('CartDrawer');
        var inner = s['cart-drawer'] && parse(s['cart-drawer'], '#CartDrawer');
        if (drawer && inner !== null) {
          drawer.innerHTML = inner;
          var ov = document.getElementById('CartDrawer-Overlay');
          var cd = document.querySelector('cart-drawer');
          if (ov && cd && cd.close) ov.addEventListener('click', cd.close.bind(cd));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        var b = s['cart-icon-bubble'] && parse(s['cart-icon-bubble'], '.shopify-section');
        if (bubble && b !== null) bubble.innerHTML = b;
        window.csFormatDates();
      })
      .catch(function () { window.location.reload(); });
  }
  function done() { busy = false; }

  function setMode(mode) {
    var s = state();
    if (!s || busy || !s.feeVariant) return;
    busy = true;
    document.querySelectorAll('.cs-po-choice').forEach(function (b) { b.classList.add('cs-po-loading'); });
    var feeQty = parseInt(s.feeQty || '0', 10);
    var otherQty = parseInt(s.otherQty || '0', 10);
    var waitQty = parseInt(s.waitQty || '0', 10);
    var p = otherQty > 0 && s.otherVariant ? setQty(s.otherVariant, 0) : Promise.resolve();
    if (mode === 'split') {
      p = p.then(function () { return waitQty > 0 ? setQty(s.waitVariant, 0) : null; });
      p = p.then(function () { return feeQty === 1 ? Promise.resolve()
        : feeQty > 1 ? setQty(s.feeVariant, 1)
        : post('/cart/add.js', { items: [{ id: Number(s.feeVariant), quantity: 1 }] }); });
      p = p.then(function () { return setAttr(SPLIT); });
    } else {
      p = p.then(function () { return feeQty > 0 ? setQty(s.feeVariant, 0) : null; });
      p = p.then(function () { return waitQty === 1 ? null : waitQty > 1 ? setQty(s.waitVariant, 1) : addWait(s); });
      p = p.then(function () { return setAttr(SINGLE); });
    }
    p.then(refresh).then(done, done);
  }

  /* Cohérence du panier à chaque mise à jour */
  /* Garde-fou : pas plus de 4 corrections automatiques par minute (évite une boucle de rechargements) */
  function tooMany() {
    try {
      var now = Date.now();
      var log = JSON.parse(sessionStorage.getItem('csPoFix') || '[]').filter(function (t) { return now - t < 60000; });
      if (log.length >= 4) return true;
      log.push(now);
      sessionStorage.setItem('csPoFix', JSON.stringify(log));
    } catch (e) {}
    return false;
  }
  function sanity() {
    var s = state();
    if (!s || busy || !s.feeVariant) return;
    var orig = setMode;
    setMode = function (m) { if (!tooMany()) orig(m); };
    try { sanityRun(s); } finally { setMode = orig; }
  }
  function sanityRun(s) {
    var feeQty = parseInt(s.feeQty || '0', 10);
    var otherQty = parseInt(s.otherQty || '0', 10);
    var waitQty = parseInt(s.waitQty || '0', 10);
    var mixed = s.mixed === 'true';
    if (!mixed) {
      if (feeQty > 0 || otherQty > 0 || waitQty > 0 || s.attr) {
        busy = true;
        var p = feeQty > 0 ? setQty(s.feeVariant, 0) : Promise.resolve();
        if (otherQty > 0 && s.otherVariant) p = p.then(function () { return setQty(s.otherVariant, 0); });
        if (waitQty > 0 && s.waitVariant) p = p.then(function () { return setQty(s.waitVariant, 0); });
        p.then(function () { return setAttr(''); }).then(refresh).then(done, done);
      }
      return;
    }
    /* Mauvais type de frais pour le pays (relais / domicile) : on remplace */
    if (otherQty > 0) { setMode(s.attr === SINGLE ? 'single' : 'split'); return; }
    if (!s.attr) { setMode('split'); return; } /* nouveau panier mixte : 2 envois par défaut */
    if (feeQty > 1) { busy = true; setQty(s.feeVariant, 1).then(refresh).then(done, done); return; }
    if (s.attr === SPLIT && feeQty === 0) { setMode('single'); return; } /* frais supprimés à la main = un seul colis */
    if (s.attr === SINGLE && feeQty > 0) { setMode('split'); return; }
    /* Ligne « expédition à réception » : présente une seule fois en « un seul colis », absente sinon */
    if (!s.waitVariant) return;
    if (s.attr === SINGLE && waitQty !== 1) { setMode('single'); return; }
    if (s.attr === SPLIT && waitQty > 0) { busy = true; setQty(s.waitVariant, 0).then(refresh).then(done, done); }
  }

  /* Dates : « vendredi 31 octobre » */
  window.csFormatDates = function () {
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    document.querySelectorAll('.js-cs-date').forEach(function (el) {
      var p = (el.dataset.date || '').split('-');
      if (p.length === 3) el.textContent = new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString(document.documentElement.lang || 'fr', opts);
    });
  };

  /* Phase de capture + stopPropagation : le composant panier du thème ne doit pas traiter ce changement */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && t.name.indexOf('cs-po-mode') === 0) { e.stopPropagation(); setMode(t.value); }
  }, true);
  function onReady() { sanity(); window.csFormatDates(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(onReady, 400); });
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(window.csFormatDates, 50); });
  }
})();
